module.exports = __webpack_public_path__ + "static/clouds-e08fea480be510e6db8db64ccdb56298.mp4";